import * as T from "@shared/types";
import { axios } from ".";

export const INSTALLATIONS_BASE_URL = "/api/v1/installations/bc-installations";

export const getInstallations = async () => {
  const response = await axios.get<{ data: T.Installation[] }>(INSTALLATIONS_BASE_URL);
  return response.data.data;
};

export const getInstallation = async (installationId: string) => {
  const url = `${INSTALLATIONS_BASE_URL}/${installationId}`;
  const response = await axios.get<{ data: T.Installation }>(url);
  return response.data.data;
};

export const putInstallation = async (installation: T.Installation) => {
  const url = `${INSTALLATIONS_BASE_URL}/${installation.id}`;
  const response = await axios.put<{ data: T.Installation }>(url, { data: installation });
  return response.data.data;
};

export const deleteInstallation = async (installation: T.Installation) => {
  const url = `${INSTALLATIONS_BASE_URL}/${installation.id}`;
  const response = await axios.delete<{ data: T.Installation }>(url, { data: installation });
  return response.data.data;
};
